import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedActiveIssuesListComponent } from './shared-active-issues-list.component';
import { RouterModule } from '@angular/router';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SharedLayoutModule } from '../../shared-layout.module';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { SharedActiveIssuesFilterModule } from './shared-active-issues-filter/shared-active-issues-filter.module';
import { WithTooltipModule } from '../with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}
@NgModule({
  declarations: [SharedActiveIssuesListComponent],
  imports: [
    CommonModule,
    RouterModule,
    SharedLayoutModule,
    WithTooltipModule,
    ControlDisabledDirectiveModule,
    SortByModule,
    SharedActiveIssuesFilterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [SharedActiveIssuesListComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class SharedActiveIssuesListModule {}
